import PropTypes from 'prop-types';
// material
import { Typography } from '@mui/material';
import {
  Timeline,
  TimelineItem,
  TimelineContent,
  TimelineConnector,
  TimelineSeparator,
  TimelineDot
} from '@mui/lab';
// utils

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

OrderItem.propTypes = {
  item: PropTypes.object,
  isLast: PropTypes.bool
};

function OrderItem({ item, isLast }) {
  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot />
        {isLast ? null : <TimelineConnector />}
      </TimelineSeparator>
      <TimelineContent>
        <Typography variant="subtitle1">{item.title}</Typography>
      </TimelineContent>
    </TimelineItem>
  );
}

VolShareAeroTimeline.propTypes = {
  aeroToucher: PropTypes.array
};
export default function VolShareAeroTimeline({ aeroToucher }) {
  const TIMELINES = aeroToucher.map((item) => ({ title: item }));

  return (
    <Timeline>
      {TIMELINES.map((item, index) => (
        <OrderItem key={item.title} item={item} isLast={index === TIMELINES.length - 1} />
      ))}
    </Timeline>
  );
}
